import { cadastro_do_responsavel_do_aluno } from "./cadastro-do-responsavel-do-aluno";
import { cadastro_de_aluno } from "./cadastro-de-aluno";

const manutencao_de_aluno = [
  cadastro_do_responsavel_do_aluno,
  cadastro_de_aluno,
];

export { manutencao_de_aluno };
